import type { RefObject } from 'react'
import { useLayoutEffect, useState } from 'react'

export const useCaretPosition = (
  inputRef: RefObject<HTMLInputElement | null>,
  value: string,
  isFocused: boolean
) => {
  const [left, setLeft] = useState(0)

  useLayoutEffect(() => {
    if (!isFocused) {
      return
    }

    const input = inputRef.current
    if (!input) {
      return
    }

    const computed = window.getComputedStyle(input)
    const canvas = document.createElement('canvas')
    const ctx = canvas.getContext('2d')
    if (!ctx) {
      return
    }

    ctx.font = `${computed.fontStyle} ${computed.fontWeight} ${computed.fontSize} ${computed.fontFamily}`
    const textWidth = ctx.measureText(value).width
    const paddingLeft = parseFloat(computed.paddingLeft) || 0

    setLeft(paddingLeft + textWidth - input.scrollLeft)
  }, [value, isFocused, inputRef])

  return left
}
